import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";
import { sanitizeFileName } from "@sf-core";
import { ExportFileNames } from "../constants/exportFileNames";

export const getNegativeTextCount = async () => {
  return base.get({
    url: `${API_PARAM.NEGATIVE_TEXT_COUNT}`,
  });
};

export const exportNegativeTextGrid = async (filterModel) => {
  return base.exportFile({
    url: API_PARAM.NEGATIVE_TEXT_EXPORT,
    data: filterModel,
    fileName: sanitizeFileName(ExportFileNames.NEGATIVE_TEXT),    
  });
};

export const uploadFromNegativeText = async () => {
  return base.post({
    url: `${API_PARAM.NEGATIVE_TEXT_UPLOAD}`,
  });
};